import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function NotFound() {
  const { t } = useLanguage();
  const containerStyle = {
    minHeight: '100vh',
    background: '#101010',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontFamily: 'inherit',
    textAlign: 'center',
    padding: '40px 20px',
  };

  const logoStyle = {
    width: '100px',
    height: 'auto',
    marginBottom: '40px',
  };

  const codeStyle = {
    fontSize: 'clamp(80px, 15vw, 160px)',
    fontWeight: 800,
    color: '#0bb4aa',
    lineHeight: 1,
    margin: 0,
    letterSpacing: '-4px',
  };

  const subtitleStyle = {
    fontSize: 'clamp(18px, 3vw, 24px)',
    color: '#aaa',
    margin: '16px 0 40px',
    fontWeight: 400,
  };

  const buttonStyle = {
    display: 'inline-block',
    padding: '14px 36px',
    background: '#0bb4aa',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.2s ease, transform 0.2s ease',
  };

  return (
    <div style={containerStyle}>
      <a href="/">
        <img src="/logo-white.png" alt="KBY Interactive" style={logoStyle} />
      </a>
      <h1 style={codeStyle}>404</h1>
      <p style={subtitleStyle}>{t('notFound.title')}</p>
      <a
        href="/"
        style={buttonStyle}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#0da69d';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#0bb4aa';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        {t('sd.backHome')}
      </a>
    </div>
  );
}

export default NotFound;
